import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import { PaymentMethod } from "../../common/types/enums";
import { PaymentMethodInterface } from "../../common/types/types";

interface PaymentMethodsState {
  data: PaymentMethodInterface[];
}

const initialState: PaymentMethodsState = {
  data: [],
};

export const paymentMethodsSlice = createSlice({
  name: "payment-methods",
  initialState,
  reducers: {
    setPaymentMethods: (state, action: PayloadAction<PaymentMethodInterface[]>) => {
      state.data = action.payload;
    },
    clearPaymentMethods: (state) => {
      state.data = [];
    },
  },
});

export const { setPaymentMethods, clearPaymentMethods } =
  paymentMethodsSlice.actions;

export const selectPaymentMethods = (state: RootState) =>
  state.paymentMethods.data;

export default paymentMethodsSlice.reducer;
